import { render, staticRenderFns } from "./MessageThreadsIcon.vue?vue&type=template&id=6998e838"
import script from "./MessageThreadsIcon.vue?vue&type=script&lang=js"
export * from "./MessageThreadsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports